import { useState } from 'react'
import { cloudWatchLogger, validateAccessCode } from '../../api'
import { Button } from '../../elements/Button'
import { ErrorLabel } from '../../elements/ErrorLabel'
import { AccessCodeInput, ApplicationTypeOptionsRow, ErrorLabelWrapper } from './styles'

type AccessCodeValidatorProps = {
  guid: string | undefined
  applicationTypeId: string | undefined
  onVerify: (value: 'idle' | 'verified' | 'unVerified') => void
  verified: boolean
}

export const AccessCodeValidator = ({ guid = '', applicationTypeId, onVerify, verified }: AccessCodeValidatorProps) => {
  const [accessCode, setAccessCode] = useState<string | undefined>(undefined)
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle')
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)

  const verifyAccessCode = () => {
    setStatus('loading')
    validateAccessCode({
      guid,
      applicationTypeId,
      accessCode,
    })
      .then(res => {
        if (!res) {
          onVerify('unVerified')
          setErrorMessage('This Access Code is not valid')
        } else {
          onVerify('verified')
        }
        setStatus('success')
      })
      .catch((error: Error) => {
        setStatus('error')
        cloudWatchLogger.error('Access Code Verification', error.message)
      })
  }

  const onInputChange = (e: any) => {
    errorMessage && setErrorMessage(undefined)
    status !== 'idle' && setStatus('idle')
    onVerify('idle')
    setAccessCode(e.target.value)
  }

  const iconClassName = `fas fa-${errorMessage ? 'times-circle' : 'check-circle'} validation-icon`

  const disableButton = !accessCode?.trim() || status !== 'idle'

  const showButton = !verified

  return (
    <ApplicationTypeOptionsRow>
      <span className="name">Access Code: </span>
      <AccessCodeInput>
        {status === 'success' && <i className={iconClassName} />}
        <input
          type="text"
          onChange={onInputChange}
        />
        {showButton && (
          <Button
            disabled={disableButton}
            showSpinner={status === 'loading'}
            label="Verify"
            onClick={verifyAccessCode}
          />
        )}
      </AccessCodeInput>
      {errorMessage && (
        <ErrorLabelWrapper>
          <ErrorLabel>{errorMessage}</ErrorLabel>
        </ErrorLabelWrapper>
      )}
    </ApplicationTypeOptionsRow>
  )
}
